const priceFormatter = (price, currency = "SEK") => {
    if (price === null || price === undefined) {
        return "0,00";
    }
    
    // Convert to a number and format
    const formattedPrice = parseFloat(price).toLocaleString("sv-SE", {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    
    return formattedPrice;
}

export default priceFormatter;